import { AppSettings } from '../common/AppSettings.ts';

declare const appSettings: AppSettings;

export default async function request(url: string, options: RequestInit = {}): Promise<any> {
  const makeRequest = async (): Promise<any> => {
    const response = await fetch(`${appSettings.apiBaseUrl}/${url}`, options);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  };

  return makeRequest();
}
